export const dragAndDrop = {
  dragAndDrop: {
  maxFiles: 'Max Files:',
  maxFileSize: 'Max File Size:',
  formats: 'Formats:',
  dragAndDropFiles: 'Drag and drop files or click',
  here: 'here',
  toUpload: 'to upload.',
  delete: 'delete',
  close: 'close',
  maxFilesExceeded: 'Maximum number of files exceeded: You can only upload up to {{maxFiles}} files.',
  fileSizeExceedsLimit: 'File size exceeds the limit: <strong>{{fileName}}</strong> is too large.',
  invalidFileType: 'Invalid file type: <strong>{{fileName}}</strong>.',
}
};